<template>
  <div class="mt-8 pt-6 border-t border-gray-100">
    <h3 class="text-sm font-semibold text-gray-700 mb-3 ml-1">Submódulos y Catálogos Auxiliares</h3>
    <div class="flex flex-wrap gap-3">
      <Link 
        href="/product-categories"
        class="px-4 py-2.5 bg-white border border-gray-200 rounded-xl text-gray-700 hover:bg-orange-50/50 hover:border-orange-200 flex items-center gap-2.5 transition-all text-sm font-medium shadow-2xs"
      >
        <div class="w-7 h-7 rounded-lg bg-orange-100 text-orange-600 flex items-center justify-center text-xs">
          <i class="fa fa-tags" />
        </div>
        <span>Categorías</span>
      </Link>

      <Link
        href="/brands" 
        class="px-4 py-2.5 bg-white border border-gray-200 rounded-xl text-gray-700 hover:bg-orange-50/50 hover:border-orange-200 flex items-center gap-2.5 transition-all text-sm font-medium shadow-2xs"
      >
        <div class="w-7 h-7 rounded-lg bg-orange-100 text-orange-600 flex items-center justify-center text-xs">
          <i class="fa fa-bookmark" />
        </div>
        <span>Marcas</span>
      </Link>
    </div>
  </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'

export default {
  name: 'ProductAuxiliaries',

  components: {
    Link,
  },
}
</script>
